var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reward-coin",style:(("transform: scale(" + _vm.calculateSize + ");margin: " + _vm.calculateMargin + "px 0"))},[_c('BackgroundCoin'),_c('div',{staticClass:"reward-coin__wrapper"},[(!_vm.isPercentage)?_c('span',{staticClass:"reward-coin__currency"},[_vm._v(_vm._s(_vm.currencySymbol))]):_vm._e(),_c('span',{staticClass:"reward-coin__value",class:{
        '--medium': String(_vm.value).length === 2,
        '--small': String(_vm.value).length >= 3
      }},[_vm._v("\n      "+_vm._s(_vm.textValue)+"\n    ")]),(_vm.isPercentage)?[_c('span',{class:[
          'reward-coin__percentage',
          {
            '--small': String(_vm.value).length === 1,
            '--medium': String(_vm.value).length > 1
          }
        ]},[_vm._v("\n        %\n      ")]),_c('span',{class:[
          'reward-coin__off',
          {
            '--small': String(_vm.value).length === 1,
            '--medium': String(_vm.value).length > 1
          }
        ]},[_vm._v("\n        OFF\n      ")])]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }